import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { io } from 'socket.io-client';
import { API_URL, WEB_URL } from '../config';

const ChatContext = createContext();
const ChatProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return userInfo ? { ...userInfo, notifications: [] } : undefined;
    } catch (e) {
      return undefined;
    }
  });
  const [taskz, setTaskz] = useState();
  const [chatRoom, setChatRoom] = useState();
  const [chatSocketId, setChatSocketId] = useState();
  const [notification, setNotification] = useState([]);
  const [selectedChat, setSelectedChat] = useState();
  const [chatActivo, setChatActivo] = useState(false);
  const [isActive, setIsActive] = useState([]);
  const [chats, setChats] = useState([]);
  const address = API_URL;
  const address_web = WEB_URL;

  // The socket carries the same JWT as the REST API. It only connects once there is a session.
  const socket = useMemo(
    () =>
      io(address, {
        autoConnect: false,
        auth: (cb) => {
          try {
            cb({ token: JSON.parse(localStorage.getItem('userInfo'))?.token });
          } catch (e) {
            cb({});
          }
        },
      }),
    [address]
  );
  const token = user?.token;
  useEffect(() => {
    if (token) socket.connect();
    else socket.disconnect();
  }, [socket, token]);

  return (
    <ChatContext.Provider
      value={{
        user,
        socket,
        setUser,
        taskz,
        setTaskz,
        selectedChat,
        chatSocketId,
        setChatSocketId,
        chatRoom,
        setChatRoom,
        setSelectedChat,
        notification,
        setNotification,
        isActive,
        setIsActive,
        chats,
        setChats,
        address,
        address_web,
        setChatActivo,
        chatActivo,
      }}
    >
      {' '}
      {children}{' '}
    </ChatContext.Provider>
  );
};

export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
